var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _path17, _path18, _polyline, _path19, _path20, _path21, _path22, _polyline2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 280 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#831616;}.h{fill:#ea989b;}.i{fill:url(#f);opacity:.6;}.j{fill:#660c08;}.k{fill:#ffdfde;}.l{fill:#54100e;}.m{fill:#fe1d00;}.n{fill:#dd3b4b;}.o{fill:url(#e);}.p{fill:#ba1200;}.q{fill:#ff506e;}.r{fill:url(#b);}.s{fill:#ff929a;}.t{fill:#9a0d01;}.u{fill:url(#d);opacity:.3;}.v{fill:url(#c);}.w{fill:#721011;}.x{fill:#a80f00;}.y{fill:#851219;}.z{fill:#6c0603;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 91.2,
    y1: 39,
    x2: 140,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 45.13,
    y1: 69.17,
    x2: 93.53,
    y2: 111.88,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 240.34,
    y1: 372.22,
    x2: 191.52,
    y2: 338.7,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 83.59,
    cy: 156.24,
    fx: 83.59,
    fy: 156.24,
    r: 262.04,
    gradientTransform: "translate(13.33 23.53) scale(.9 .88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff1d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e0502"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 115.14,
    y1: 135.47,
    x2: 230.46,
    y2: 239.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54100e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad1d30"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M140,0l-25.41,77.99-23.39-25.66C117.87,19.81,140,0,140,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M140,0l-25.41,77.99-23.39-25.66C117.87,19.81,140,0,140,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M114.59,77.99l-.03,.09L41.76,123.69c15.53-27.4,33.32-51.7,49.44-71.36l23.39,25.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M114.59,77.99l-.03,.09L41.76,123.69c15.53-27.4,33.32-51.7,49.44-71.36l23.39,25.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M55.14,196.83L.1,256.51c1.5-47.53,19.25-93.37,41.64-132.8,.06,.56,3.27,30.18,13.4,73.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M87.18,162.09l-22.83,70.05c-3.57-12.47-6.61-24.33-9.21-35.32l32.04-34.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M49.01,279.22l-23.53,72.22c-12.08-16.15-21.1-37.67-24.25-66.34-1.09-9.57-1.43-19.11-1.13-28.59l48.91,22.71Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M139.95,399.93v.07c-11.74,0-43.9-.56-74.41-15.66l40.59-42.38c9.8,19.81,21.01,39.38,33.83,57.97Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M106.13,341.97l-40.59,42.38c-14.51-7.17-28.66-17.64-40.06-32.91l79.03-8.89,1.46-.89c.05,.11,.1,.2,.16,.31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M214.44,384.36c-30.58,15.13-74.48,15.64-74.48,15.64v-.07c12.7-18.41,23.83-37.8,33.57-57.43l40.91,41.86Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M254.23,351.83c-11.36,15.06-25.39,25.41-39.79,32.53l-40.91-41.86c.02-.06,.05-.11,.08-.17l.34,.21,80.28,9.28Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M254.23,351.83c-11.36,15.06-25.39,25.41-39.79,32.53l-40.91-41.86c.02-.06,.05-.11,.08-.17l.34,.21,80.28,9.28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M278.77,285.1c-3.18,28.91-12.31,50.54-24.54,66.73l-23.56-72.59,49.24-22.72c.29,9.47-.05,19-1.13,28.57Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M279.9,256.52l-55.2-59.32c10.32-43.57,13.53-73.55,13.53-73.55,22.4,39.45,40.16,85.3,41.66,132.86Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M188.21,51.61l-23.19,25.45L140,0s21.8,19.52,48.21,51.61Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M238.23,123.66l-73.22-46.6,23.19-25.45c16.28,19.78,34.29,44.34,50.03,72.05Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "p",
    points: "165.01 77.05 139.37 105.18 114.63 78.04 114.59 77.99 140 0 165.01 77.05"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M105.97,341.66l-1.46,.89-79.03,8.89,23.53-72.22,36.99,17.17c5.89,14.99,12.52,30.19,19.97,45.27Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M254.23,351.83l-80.28-9.28-.34-.21c7.63-15.38,14.39-30.89,20.4-46.17l36.66-16.92,23.56,72.59Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "j",
    points: "139.37 105.18 165.01 77.05 192.94 163.08 139.37 105.51"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M215.48,232.49h0c-5.74,20.03-12.81,41.62-21.47,63.67l-54.39,25.1-53.61-24.89c-8.75-22.26-15.88-44.05-21.65-64.24l22.83-70.05,52.19-56.58,53.57,57.57,22.53,69.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M279.9,256.52l-49.24,22.72-15.19-46.75h0c3.57-12.46,6.63-24.31,9.22-35.3l55.2,59.32Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M64.35,232.14l-15.34,47.07L.1,256.51l55.04-59.68c2.6,10.98,5.64,22.84,9.21,35.32Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M86,296.38l-36.99-17.17,15.34-47.07c5.77,20.19,12.9,41.98,21.65,64.24Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "x",
    points: "139.37 105.51 87.18 162.09 114.56 78.08 114.63 78.04 139.37 105.18"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M114.56,78.08l-27.38,84.01-32.04,34.74c-10.13-42.94-13.34-72.56-13.4-73.12h0s.02-.02,.02-.02l72.8-45.61Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M139.61,321.27l-33.64,20.39c-7.45-15.08-14.08-30.28-19.97-45.27l53.61,24.89Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M173.53,342.5c-9.74,19.62-20.87,39.02-33.57,57.43-12.81-18.58-24.03-38.16-33.83-57.97-.05-.11-.1-.2-.16-.31l33.64-20.39,33.39,20.7,.52,.54Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M194,296.16c-6.01,15.29-12.85,30.96-20.48,46.34l-.52-.54-33.39-20.7,54.39-25.1Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M230.66,279.25l-36.66,16.92c8.66-22.05,15.74-43.64,21.47-63.67l15.19,46.75Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M224.7,197.2c-2.6,10.98-5.65,22.84-9.22,35.29l-22.53-69.41,31.76,34.12Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M238.23,123.66s-3.21,29.97-13.53,73.55l-31.76-34.12-27.93-86.03,73.22,46.6Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M215.47,232.46h0c-5.73,20.02-12.81,41.61-21.46,63.65l-54.37,25.1-53.69-24.89c-8.75-22.25-15.89-44.06-21.65-64.24l22.93-69.99,52.15-56.58,53.57,57.57,22.52,69.38Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "215.48 232.49 215.48 232.5 183.73 215.07 87.18 162.09 139.37 105.51 192.94 163.08 215.48 232.49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.d618ff090f550b270ada9fdba1bd31fd.svg";
export { ForwardRef as ReactComponent };